// @ts-ignore
import TWEEN from 'tween.js'

interface ScrollOptions {
  boundary?: string
  duration?: number
  easing?: TWEEN.Easing
  el?: any
  fit?: boolean
  offset?: number
  onComplete?: () => void
}

const defaultOptions = {
  boundary: 'top',
  duration: 1000,
  easing: TWEEN.Easing.Quartic.InOut,
  el: undefined,
  fit: true,
  offset: 0,
  onComplete: undefined,
}

export function scrollToPosition(x, y, opts?: ScrollOptions) {
  const options = {
    ...defaultOptions,
    ...opts,
  }
  const el = options.el
  const setScrollProps = (xv, yv) => {
    if (el) {
      el.scrollLeft = xv
      el.scrollTop = yv
    } else {
      window.scrollTo(xv, yv)
    }
  }
  if (options.duration === 0) {
    setScrollProps(x, y)
  } else {
    let animate = () => {
      requestAnimationFrame(animate)
      TWEEN.update()
    }
    const coords: any = {
      x: el
        ? el.scrollLeft
        : window.pageXOffset || document.documentElement.scrollLeft,
      y: el
        ? el.scrollTop
        : window.pageYOffset || document.documentElement.scrollTop,
    }
    new TWEEN.Tween(coords)
      .easing(options.easing)
      .to({ x: x || 0, y: y || 0 }, options.duration)
      .onUpdate(() => {
        setScrollProps(coords.x, coords.y)
      })
      .onComplete(() => {
        animate = () => null
        if (typeof options.onComplete === 'function') {
          options.onComplete()
        }
      })
      .start()
    requestAnimationFrame(animate)
  }
}

export function scrollToSelector(selector, opts?: ScrollOptions) {
  const options = {
    ...defaultOptions,
    ...opts,
  }
  const el = document.querySelector(selector)
  if (!el) {
    return
  }
  const rect = el.getBoundingClientRect()
  let yPos =
    (options.el ? options.el.scrollTop : window.scrollY) +
    (rect[options.boundary] -
      (options.el ? options.el.offsetHeight : window.innerHeight)) +
    options.offset
  if (options.fit && rect[options.boundary] - rect.height < yPos) {
    yPos = rect[options.boundary] - rect.height - options.offset
  }
  scrollToPosition(0, yPos, options)
}
